import { render } from "./form-email.vue?vue&type=template&id=1a82ecfa"
import script from "./form-email.vue?vue&type=script&lang=js"
export * from "./form-email.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__